import { TMSImageryProvider } from "./TMSImageryProvider";
export class CesiumIonImageryProvider extends TMSImageryProvider {
    constructor(baseUrl, tileMap, cesiumOptions) {
        const options = TMSImageryProvider.httpOptionsFromTileMapInfo(tileMap);
        super(baseUrl, tileMap, options);
        this._authHeader = cesiumOptions.authHeader;
        this._attributions = cesiumOptions.attributions;
    }
    get attributions() {
        return this._attributions;
    }
    resolveRequestOptions() {
        return {
            headers: {
                Authorization: this._authHeader,
            },
        };
    }
}
